var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * WarningCircleFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconWarningCircleFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 5.91071C12.6509 5.91071 13.1786 6.43838 13.1786 7.08929V12.1964C13.1786 12.8473 12.6509 13.375 12 13.375C11.3491 13.375 10.8214 12.8473 10.8214 12.1964V7.08929C10.8214 6.43838 11.3491 5.91071 12 5.91071ZM13.5714 16.5179C13.5714 17.3858 12.8679 18.0893 12 18.0893C11.1321 18.0893 10.4286 17.3858 10.4286 16.5179C10.4286 15.65 11.1321 14.9464 12 14.9464C12.8679 14.9464 13.5714 15.65 13.5714 16.5179Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconWarningCircleFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningCircleFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningCircleFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-warning-circle-filled') === undefined) {
    customElements.define('cat-icon-warning-circle-filled', BlocksIconWarningCircleFilled);
}
